import classNames from 'classnames';
import type { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const ListItemLoadingSkeleton: FC<{
  isLast?: boolean;
  columns?: { className: string; content: any }[];
}> = ({ isLast, columns }) => (
  <div className="mb-6">
    <div className="flex items-center justify-between space-x-3">
      {columns?.map(({ className, content }, ndx) => (
        <div key={ndx} className={className}>
          {content}
        </div>
      ))}
    </div>

    <Skeleton className={classNames('h-[1px] mt-6', { invisible: isLast })} />
  </div>
);

const ListLoadingSkeleton: FC<{
  count?: number;
  columns?: { className: string; content: any }[];
}> = ({ count = 10, columns }) => {
  const skeletonUI = Array(count)
    .fill(null)
    .map((_, index) => (
      <ListItemLoadingSkeleton
        key={index}
        isLast={index === count - 1}
        columns={columns}
      />
    ));

  return <>{skeletonUI}</>;
};

export default ListLoadingSkeleton;
